<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <v-row justify="start" align="start" class="ma-0 mt-5 mb-4">
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #193D6E;">{{ texts.conversionsHistory.title }}</div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            {{ texts.conversionsHistory.subTitle }}
          </div>
        </v-col>
      </v-row>
      <v-row class="ma-0 mb-4" style="align-items: center;">
        <v-col class="pl-0">
          <div style="width: 208px; max-width: 208px;">
            <v-text-field v-model="search" label="Buscar" hide-details style="font-family: 'montserrat-medium'; border-radius: 20px; background-color: white;" append-icon="mdi-magnify" outlined></v-text-field>
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col style="text-align: end;">
          <v-btn
            color="#0075B8"
            elevation="8"
            class="white--text"
            style="border-radius: 36px; border: 2px solid #0075BB; font-family: 'montserrat-semibold'; text-transform: none;"
            @click="dataXLSX()"
          >
            <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
            {{ texts.suppliers.download }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="ma-0 mb-4">
        <v-col class="d-flex justify-end py-0">
          <div class="d-flex align-center" style="width: fit-content; background: #BFD7ED; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15); border-radius: 10px; padding: 15px; border: 1px solid #C5CDD3;">
            <div class="pa-1 mr-3" style="background-color: #ECF6FF; border-radius: 5px;">
              <v-img src="../../assets/icons/trending-up.svg" style="width: 24px;"></v-img>
            </div>
            <div class="mr-1" style="font-family: 'montserrat-semibold';">{{ texts.conversionsHistory.totalCurrencyGain + ": " }}</div>
            <span style="font-family: 'montserrat-bold'" :style="{ color: totalProfit < 0 ? '#0075B8' : '#0075B8'}"> 
              {{ " $" + formatMoney(totalProfit) + " " + ($store.state.sTypeAccount == 'EFEXUSD' ? 'USD' : 'MXN')}}
            </span>
          </div>
        </v-col>
      </v-row>
      <v-data-table :headers="headersForex" hide-default-header :search="search" :items="items" class="mb-4 d-none d-sm-block">
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">{{ texts.conversions.id }}</th>
              <th class="header__title center">{{ texts.conversions.transactionDate }}</th>
              <th class="header__title center">{{ texts.conversions.typeTransaction }}</th>
              <th class="header__title center">{{ texts.conversions.exchangeRate }}</th>
              <th class="header__title center">{{ texts.conversions.totalAmountUSD }}</th>
              <th class="header__title center">{{ texts.conversions.totalAmountMXN }}</th>
              <th class="header__title center">{{ texts.conversions.invoice }}</th>
              <th class="header__title center" style="text-wrap: wrap;">{{ texts.conversions.dollarProfit }}</th>
              <th class="header__title center" style="text-wrap: wrap;">{{ texts.conversions.currencyProfit }}</th>
              <th class="header__title right">{{ texts.conversions.actions }}</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.iTrackingId }}</td>
              <td class="table__item">{{ formatDate(item.created_at) }}</td>
              <td class="table__item">
                <v-chip v-if="item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                  {{ "Forward" }}
                </v-chip>
                <v-chip v-else-if="item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                  {{ "Forex" }}
                </v-chip>
                <v-chip v-else-if="item.sTransactionType == '1e337607-b37b-4491-83b0-6383a45f9481'" color="#0EAB5D" style="background-color: #EFFAF2 !important;" outlined>
                  {{ "Withdrawal" }}
                </v-chip>
                <v-chip v-else-if="item.sTransactionType == 'f588edfa-73d4-4365-a240-90a3339dfdb2'" color="#603CB5" style="background-color: #F4F0F8 !important;" outlined>
                  {{ "Collect" }}
                </v-chip>
                <v-chip v-else-if="item.sTransactionType == 'ea9d350f-f00b-4763-90db-72e7af54dc73'" color="#E8B238" style="background-color: #FDF8EB !important;" outlined>
                  {{ "Pay Now" }}
                </v-chip>
                <v-chip v-else-if="item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                  {{ "Window spot" }}
                </v-chip>
                <h4 v-else>
                  {{ "-" }}
                </h4>
              </td>
              <td class="table__item">$ {{ formatMoney(item.dExchangeRate) }} MXN</td>
              <td class="table__item">$ {{ formatMoney(item.dAmount) }} {{ item.sCurrency || 'USD' }}</td>
              <td class="table__item">$ {{ formatMoney(item.dDesAmount) }} {{ item.sDestCurrency || 'MXN' }}</td>
              <td class="table__item">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" style="text-overflow: ellipsis; max-width: 100px; overflow: hidden;">
                      {{ item.invoiceDisplay ? item.invoiceDisplay : "-" }}
                    </div>
                  </template>
                  <span>{{ item.invoiceDisplay ? item.invoiceDisplay : "-" }}</span>
                </v-tooltip>
              </td>
              <td class="table__item" :style="item.dollarProfit >= 0 ? 'color: #4CAF50;' : 'color: #E74C3C;'">{{ item.dollarProfit ? "$ " + formatMoney(item.dollarProfit) + " " + ($store.state.sTypeAccount == 'EFEXUSD' ? 'USD' : 'MXN') : "-" }}</td>
              <td class="table__item" :style="item.dollarProfit >= 0 ? 'color: #4CAF50;' : 'color: #E74C3C;'">{{ item.percentProfit ? formatMoney(item.percentProfit) + "%" : "-" }}</td>
              <td class="table__item">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="openDialog(item)" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ texts.conversionsHistory.viewDetail }}</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-data-table class="d-sm-none d-block" hide-default-header :items="items">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr class="table__item" style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
              <td class="table__item__mobile">
                <div>{{ texts.conversions.id }}</div>
                <div>{{ item.iTrackingId }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.transactionDate }}</div>
                <div>{{ formatDate(item.created_at)}}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.typeTransaction }}</div>
                <div>
                  <v-chip v-if="item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                    {{ "Forward" }}
                  </v-chip>
                  <v-chip v-else-if="item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                    {{ "Forex" }}
                  </v-chip>
                  <v-chip v-else-if="item.sTransactionType == '1e337607-b37b-4491-83b0-6383a45f9481'" color="#0EAB5D" style="background-color: #EFFAF2 !important;" outlined>
                    {{ "Withdrawal" }}
                  </v-chip>
                  <v-chip v-else-if="item.sTransactionType == 'f588edfa-73d4-4365-a240-90a3339dfdb2'" color="#603CB5" style="background-color: #F4F0F8 !important;" outlined>
                    {{ "Collect" }}
                  </v-chip>
                  <v-chip v-else-if="item.sTransactionType == 'ea9d350f-f00b-4763-90db-72e7af54dc73'" color="#E8B238" style="background-color: #FDF8EB !important;" outlined>
                    {{ "Pay Now" }}
                  </v-chip>
                  <v-chip v-else-if="item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                    {{ "Window spot" }}
                  </v-chip>
                  <h4 v-else>
                    {{ "-" }}
                  </h4>
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.exchangeRate }}</div>
                <div>$ {{ formatMoney(item.dExchangeRate) }} MXN</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.totalAmountUSD }}</div>
                <div>$ {{ formatMoney(item.dAmount) }} {{ item.sCurrency || 'USD' }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.totalAmountMXN }}</div>
                <div>$ {{ formatMoney(item.dDesAmount) }} {{ item.sDestCurrency || 'MXN' }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.invoice }}</div>
                <div>{{ item.invoiceDisplay ? item.invoiceDisplay : "-" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.dollarProfit }}</div>
                <div style="color: #0075B8;">{{ item.dollarProfit ? "$ " + formatMoney(item.dollarProfit) + " USD" : "-" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.currencyProfit }}</div>
                <div style="color: #0075B8;">{{ item.percentProfit ? formatMoney(item.percentProfit) + "%" : "-" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.actions }}</div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="openDialog(item)" v-bind="attrs" v-on="on" icon color="black">
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ texts.conversionsHistory.viewDetail }}</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
            <v-divider></v-divider>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog v-model="dialogConversionDetail" max-width="1400px" scrollable>
      <v-card>
        <v-card-text class="pa-0">
          <ConversionDetail
            v-if="selectedTransactionId"
            :s-transaction-id="selectedTransactionId"
            @back="dialogConversionDetail = false"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import ConversionDetail from "./ConversionDetail.vue";

export default {
  name: "DashboardView",
  components: {
    ConversionDetail,
  },
  data() {
    return {
      nameXLSX: "HistorialConversiones.xlsx",
      texts: "",
      drawer: null,
      search: "",
      dialogDetailConversion: false,
      conversion: {},
      actualCurrency: "0",
      actualCurrencyMxn: "0",
      referenceCurrency: "0",
      isLoading: false,
      isRegisterEfex: true,
      exchangeRateData: [],
      selected: [],
      exchangeRateDataPaid: [],
      exchangeRateDataSeparate: [],
      balanceMxn: "0",
      balanceUsd: "0",
      balance: "0",
      items: [],
      tab: 0,
      contacts: [],
      itemsSelected: [],
      itemsSelectedForwards: [],
      isForwardRateCalculated: false,
      bSelectedAll: false,
      dialogAddFoundss: false,
      dialogSendPay: false,
      dialogAddFounds: false,
      dataAddFounds: {},
      dialogCreate: false,
      dialogPay: false,
      editableData: {},
      selectedCard: null,
      totalUsd: 0,
      selectedMenuItem: "dashboard",
      contactData: {
        sName: "",
        sEmail: "",
        sBank_name: "",
        sAccount_number: "",
        sEntity_business: "COMPANY"
      },
      isForwardsActive: false,
      showCreateProvider: false,
      isResponsive: false,
      screenWidth: 0,
      bLoading: false,
      isDeferredPayment: false,
      stepper: false,
      e1: 1,
      timerCount: 30,
      headersForex: [
        { text: "Id", value: "iTrackingId", align: "center", sortable: false },
        { text: "Creation date", value: "created_at", align: "center" },
        { text: "Type transaction", value: "sTransactionType", align: "center" },
        { text: "Target account", value: "sTargetAccount", align: "center" },
        { text: "Total amount USD", value: "dAmount", align: "center" },
        { text: "Total amount MXN", value: "dDesAmount", align: "center" },
        { text: "Exchange rate", value: "dExchangeRate", align: "center" },
        { text: "Client", value: "client", align: "center", sortable: false },
        { text: "Invoice", value: "invoice", align: "center", sortable: false },
        { text: "Purchase date", value: "purchaseDate", align: "center", sortable: false },
        { text: "Currency gain", value: "dollarProfit", align: "center", sortable: false },
        { text: "Currency profit (%)", value: "percentProfit", align: "center", sortable: false },
        { text: "Actions", value: "actions", align: "center", sortable: false },
       ],
      timerId: null,
      totalProfit: "",
      dataEfex: {},
      exchangeRateAdjustments: [],
      exchangeRatesStateForwards: [],
      isPayMxn: false,
      bSelectedAllSeparate: false,
      dialogEditProfileActive: false,
      dialogConversionDetail: false,
      selectedTransactionId: null,
      isForwards: false,
      isForwardsPayment: false,
      userName: "",
      modalCurrency: 0,
      loadingTransaction: false,
      miniVariant: true,
      expandOnHover: false,
      transactions: [],
      invoices: []
    };
  },
  methods: {
    openDialog(item) {
      this.selectedTransactionId = item.sTransactionId;
      this.dialogConversionDetail = true;
    },
    getConversionsWithId(item) {
      this.loadingTransaction = true;
      this.conversion = [];

      const payload = {
        sTransactionId: item.sTransactionId,
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/transactions/detail`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          this.conversionWithId = response.data.transactions.map(transaction => {
            let totalAmount = 0;
            let totalAmountPay = 0;
            if (transaction.invoice.length > 0) {
              transaction.invoice.map(invoice => {
                totalAmount += parseFloat(invoice.invoice.dTotalAmount);
              });
            }
            if (transaction.payment.length > 0) {
              transaction.payment.map(payment => {
                totalAmountPay += parseFloat(payment.payment.dDescAmount);
              });
            }
            transaction.totalAmount = totalAmount;
            transaction.totalAmountPay = totalAmountPay;

            transaction.percent = (transaction.totalAmount / transaction.dDesAmount) * 100
            transaction.percentPay = (transaction.totalAmountPay / transaction.dDesAmount) * 100
            return transaction;
          });

          this.conversion = this.conversionWithId[0];

          if (this.conversion.invoice.length > 0) {
            this.sPaymentRecipientId = this.conversion.invoice[0].invoice.paymentsRecipent[0].sPaymentRecipientId
          } else {
            this.sPaymentRecipientId = null;
          }
          this.loadingTransaction = false;
        })
        .catch((error) => {
          this.loadingTransaction = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    cancel() {
      this.dialogDetailConversion = false;
    },
    getPaymentsHistory() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/transactions/history`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      }).then((response) => {
        this.totalProfit = response.data.totalProfit;
        this.balanceUsd = response.data.balance.balanceUsd.balance;
        this.blockedUsd = response.data.balance.blocked.balance;
        this.items = response.data.transactions.map((transaction) => {
          let invoices = []
          let purchaseDate = []
          if (transaction.invoiceMX && transaction.invoiceMX.length > 0) {
            transaction.invoiceMX.map((invoiceMX) => {
              invoices.push(invoiceMX.sInvoice)
              purchaseDate.push(this.formatDate(invoiceMX.dPurchaseDate))
            });
          } else if (transaction.invoice && transaction.invoice.length > 0) {
            transaction.invoice.map((invoice) => {
              if (invoice.invoice) {
                invoices.push(invoice.invoice.sInvoice)
                purchaseDate.push(this.formatDate(invoice.invoice.dPurchaseDate))
              }
            });
          }
          transaction.invoiceDisplay = invoices.join(', ');
          transaction.purchaseDate = purchaseDate.join(', ');
          return transaction;
        });
        this.isLoading = false;
      }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    formatMoney: function (value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(formattedNumber);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    dataXLSX() {
      const transactionTypeMap = {
        'b80e8dc6-4138-449e-8903-968efb8437b3': 'Forward',
        'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a': 'Forex',
        '1e337607-b37b-4491-83b0-6383a45f9481': 'Withdrawal',
        'f588edfa-73d4-4365-a240-90a3339dfdb2': 'Collect',
        'ea9d350f-f00b-4763-90db-72e7af54dc73': 'Pay Now',
        '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf': 'Window spot'
      };

      try {
        let data = this.items.map((item) => {
          return {
            Id: item.iTrackingId ? item.iTrackingId : "",
            "Fecha de creación": item.created_at ? this.formatDate(item.created_at) : "",
            "Type Transaction": transactionTypeMap[item.sTransactionType] || 'N/A',
            "Exchange rate": item.dExchangeRate ? item.dExchangeRate : "",
            "Origin amount": item.dAmount ? parseFloat(item.dAmount) : "",
            "Destination amount": item.dDesAmount ? parseFloat(item.dDesAmount) : "",
            Invoice: item.invoiceDisplay ? item.invoiceDisplay : "",
            "Currency gain (USD)": item.dollarProfit ? parseFloat(item.dollarProfit) : "",
            "Currency profit (%)": item.percentProfit ? parseFloat(item.percentProfit) : "",
            "Currency origin": item.sCurrency ? item.sCurrency : "USD",
            "Currency destination": item.sDestCurrency ? item.sDestCurrency : "MXN",
          };
        });
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(blob, this.nameXLSX);
        this.success = true;
        this.msgSuccess = "Descargando documento";
      } catch (error) {
        this.error = true;
        this.codeError = "CSV_NO_DATA";
      }
    },
    updateHeaders() {
      this.headersForex = [
        { text: this.texts.conversions.id, value: "iTrackingId", align: "center" },
        { text: this.texts.conversions.transactionDate, value: "created_at", align: "center" },
        { text: this.texts.conversions.typeTransaction, value: "sTransactionType", align: "center" },
        { text: this.texts.conversions.targetAccount, value: "sTargetAccount", align: "center" },
        { text: this.texts.conversions.totalAmountUSD, value: "dAmount", align: "center" },
        { text: this.texts.conversions.totalAmountMXN, value: "dDesAmount", align: "center" },
        { text: this.texts.conversions.exchangeRate, value: "dExchangeRate", align: "center" },
        { text: this.texts.conversions.client, value: "client", align: "center", sortable: false },
        { text: this.texts.conversions.invoice, value: "invoice", align: "center", sortable: false },
        { text: this.texts.conversions.purchaseDate, value: "purchaseDate", align: "center", sortable: false },
        { text: this.texts.conversions.dollarProfit, value: "dollarProfit", align: "center" },
        { text: this.texts.conversions.currencyProfit, value: "percentProfit", align: "center", sortable: false },
        { text: this.texts.conversions.actions, value: "actions", align: "center" }
      ]
    }
  },
  beforeMount() {
    this.texts = FILE.takeRate[this.selectLanguage];
    this.getPaymentsHistory();
    this.updateHeaders();
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    }
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.takeRate[this.selectLanguage];
      }
      this.updateHeaders();
    }
  }
};
</script>

<style scoped>
.bg-container {
  width: 100%;
  background: #fff;
  opacity: 1;
  height: 100%;
}
.full-height {
  height: 100vh;
  width: 100%;
  overflow-y: auto;
}
.active {
  background-color: #f0f0f0;
}
/* .active-section .v-list-item__icon {
  color: yellow !important;
  background-color: yellow !important;
}

.active-section .v-list-item__title {
  background-color: yellow !important;
} */

.active-item {
  background-color: #f5f7f9 !important;
}
.button-add {
  background: transparent linear-gradient(258deg, #ffc556 0%, #fffc81 100%) 0%
    0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #283c4d;
  text-transform: initial;
}
.v-tabs-slider {
  background: #f0be43 !important;
  height: 3px;
  color: #f0be43 !important;
  border-radius: 100px;
}

.card-main {
  width: 40vh;
  height: 16vh;
  position: relative;
  background: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  overflow: hidden;
}

.card-content {
  position: absolute;
  top: 19px;
  left: 16px;
}

.circle-content {
  text-align: center;
  color: white;
  margin: auto;
}

.btn-custom {
  color: #f0be43;
}

.card-title {
  color: #302e2e;
  font-size: 16px;
  font-family: montserrat-bold;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 8px;
}

.card-info,
.balance-title {
  color: #777777;
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
}

.card-mxn {
  width: 200px;
  color: #f0be43;
  font-size: 24px;
  font-family: Mons;
  font-weight: 700;
  line-height: 36px;
  font-style: normal;
  word-wrap: break-word;
}

.container-width,
.header-container {
  max-width: 1280px;
  margin: auto;
}

.title-medium {
  font-family: "montserrat-semibold";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.headline-medium {
  font-family: "montserrat-semibold";
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  text-align: left;
}

.body-large {
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}

.blocked-amount {
  font-family: "montserrat-regular";
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.blocked-amount-2 {
  color: #302e2e;
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
}

.circle-sheet {
  width: 200px;
  height: 200px;
  padding-left: 17px;
  padding-right: 62px;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  position: absolute;
  right: -60px;
  top: -20px;
}

.usd-balance {
  color: #666565;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.content-balance {
  color: #302e2e;
  font-family: "montserrat-medium", sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  text-align: left;
  padding-top: 10px;
}

.h5 {
  font-family: "montserrat-bold";
  font-size: 24px;
  line-height: 36px;
  text-align: left;
}

.buttonAddFounds {
  text-align: center;
  color: #f0be43;
  font-size: 16px;
  font-family: "montserrat-semibold";
  font-weight: 600;
  line-height: 24px;
  text-transform: capitalize;
  word-wrap: break-word;
}

.modalTextAddFounds {
  color: #302e2e;
  font-family: "Montserrat-Regular", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.table th {
  background-color: #f2f2f4;
  /* border: 1px solid #ccc; */
}

@media (max-width: 1150px) {
  .card-title {
    font-size: 14px;
  }

  .card-mxn {
    font-size: 20px;
  }

  .usd-balance {
    font-size: 12px;
  }

  .content-balance {
    font-size: 18px;
  }

  .blocked-amount {
    font-size: 12px;
  }

  .blocked-amount-2 {
    font-size: 14px;
  }

  .buttonAddFounds {
    font-size: 14px;
  }

  .circle-sheet {
    display: none;
  }
}

@media (max-width: 1250px) {
  .circle-sheet {
    width: 155px;
    height: 170px;
    padding-left: 17px;
    padding-right: 40px;
    right: -50px;
    top: -5px;
  }
}
</style>
